import request from '@/utils/request'

/**
 * 客户列表查询
 * POST /kami/owner/list
 */
export function getCustomerList(data) {
  return request({
    url: '/kami/owner/list',
    method: 'post',
    data
  })
}

/**
 * 新增客户
 * POST /kami/owner/addOwner
 */
export function addCustomer(data) {
  return request({
    url: '/kami/owner/addOwner',
    method: 'post',
    data
  })
}

/**
 * 删除客户
 * POST /kami/owner/delOwner
 * body: [id]
 */
export function delCustomer(id) {
  return request({
    url: '/kami/owner/delOwner',
    method: 'post',
    data: [id]
  })
}

/**
 * 批量导入客户
 * POST /kami/owner/importOwner
 * body: FormData
 */
export function importOwner(formData) {
  return request({
    url: '/kami/owner/importOwner',
    method: 'post',
    data: formData,
    headers: { 'Content-Type': 'multipart/form-data' }
  })
}

/**
 * 修改客户
 * POST /kami/owner/updateOwner
 */
export function updateCustomer(data) {
  return request({
    url: '/kami/owner/updateOwner',
    method: 'post',
    data
  })
}

/**
 * 导出客户
 * POST /kami/owner/exportOwner
 * responseType: blob
 */
export function exportOwner(data) {
  return request({
    url: '/kami/owner/exportOwner',
    method: 'post',
    data,
    responseType: 'blob'
  })
}

/**
 * 获取客户详情
 * GET /kami/owner/getOwnerDetail/{ownerId}
 */
export function getOwnerDetail(ownerId) {
  return request({
    url: `/kami/owner/getOwnerDetail/${ownerId}`,
    method: 'get'
  })
}
